import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { UpdateCompanyState } from "../Store";
import { deleteCompany, updateIsArchive } from "../Store/Thunk";
import {
  AdminListCard,
  AdminListMain,
  AdminActions,
  AdminButton,
  AdminSwitch,
  ConfirmDeleteButton,
} from "../../../SharedComponents/ListView";

export default function CompanyList({ isArchiveActive }) {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const companyList = useSelector((state) => state.company.companyList);

  const HandleUpdateButton = (company) => {
    dispatch(UpdateCompanyState({ id: company.id, name: company.name, isUpdateOperation: true }));
  };

  return (
    companyList &&
    companyList.map((company, i) => {
      if (!!company.isArchive !== isArchiveActive) return null;

      return (
        <AdminListCard key={"company" + i} tag={company.tag}>
          <AdminListMain>
            <span className="admin-list-id">{company.id}</span>
            <span className="admin-list-title">{company.name}</span>
            <AdminActions className="ms-2">
              <AdminButton onClick={() => navigate("/companyUsers", { state: company })}>
                {t("usersButtonLabel")}
              </AdminButton>
              <AdminButton onClick={() => navigate("/credits", { state: company })}>
                {t("creditsButtonLabel")}
              </AdminButton>
              <AdminButton onClick={() => navigate("/companyInfo", { state: company })}>
                {t("settingsButtonLabel")}
              </AdminButton>
            </AdminActions>
          </AdminListMain>
          <AdminActions>
            <AdminSwitch
              label={t("archive")}
              checked={!!company.isArchive}
              onChange={(e) => dispatch(updateIsArchive({ id: company.id, isArchive: e.target.checked }))}
            />
            <AdminButton variant="outline" onClick={() => HandleUpdateButton(company)}>
              {t("updateButtonLabel")}
            </AdminButton>
            <ConfirmDeleteButton
              label={t("deleteButtonLabel")}
              onConfirm={() => dispatch(deleteCompany({ id: company.id }))}
            />
          </AdminActions>
        </AdminListCard>
      );
    })
  );
}
